
export const ORDER_SPLIT_STATE = [
    {name: 'Commande en attente', value: 'EK_ORDER_PENDING'},
    {name: 'Commande en préparation', value: 'EK_ORDER_IN_PREPARATION'},
    {name: 'Livraison en cours ', value: 'EK_ORDER_IN_DELIVERY'},
    {name: 'Pos livré ', value: 'DELIVERED_POS'},
    {name: 'Client livré', value: 'EK_ORDER_DELIVERED'},
    {name: 'Commande annulée', value: 'EK_CLIENT_ORDER_CANCELED'},
]